"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeUnitDropdownEnum = void 0;
const tslib_1 = require("tslib");
const UngroupedDropdownWidget_1 = tslib_1.__importDefault(require("../dropdown/ungrouped/UngroupedDropdownWidget"));
var TimeUnitDropdownEnum;
(function (TimeUnitDropdownEnum) {
    TimeUnitDropdownEnum["DAYS"] = "Dage";
    TimeUnitDropdownEnum["WEEKS"] = "Uger";
    TimeUnitDropdownEnum["MONTHS"] = "M\u00E5neder";
})(TimeUnitDropdownEnum = exports.TimeUnitDropdownEnum || (exports.TimeUnitDropdownEnum = {}));
class TimeUnitDropdownModel {
    constructor(noOptionText = null, shouldSelectIfSingleOption = true) {
        this.noOptionText = noOptionText;
        this.shouldSelectIfSingleOption = shouldSelectIfSingleOption;
    }
    formatItem(item) {
        return item;
    }
    isEqual(a, b) {
        return a === b;
    }
    getTextForNoOptionSelected() {
        return this.noOptionText;
    }
    selectIfSingleOption() {
        return this.shouldSelectIfSingleOption;
    }
}
class TimeUnitDropdown extends UngroupedDropdownWidget_1.default {
    constructor(args) {
        super({
            ...args,
            label: args.label || "Enhed",
            model: new TimeUnitDropdownModel(args.noOptionText, args.selectIfSingleOption),
            placeholder: args?.placeholder || "Vælg enhed"
        });
        this.setOptions([
            TimeUnitDropdownEnum.DAYS,
            TimeUnitDropdownEnum.WEEKS,
            TimeUnitDropdownEnum.MONTHS
        ]);
    }
    decorateUngroupedDropdownElement(args) {
        const dropdownElement = this.element;
        this.element = document.createElement("div");
        this.element.classList.add("package-dropdown");
        this.add(this.labelElement);
        this.add(dropdownElement);
        this.add(this.hintElement);
    }
}
exports.default = TimeUnitDropdown;
//# sourceMappingURL=TimeUnitDropdown.js.map